module.exports = __webpack_public_path__ + "static/img/4.39b4a7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/4.jpg
// module id = VINc
// module chunks = 15